import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AccuracyComponent } from "./accuracy.component";

const routes: Routes = [
  {
    path: "",
    component: AccuracyComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccuracyRoutingModule {}
